import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isconfirmOrderOpen:false,
    User:null,
    LogoutLouding:false,
    login:true,
    orders:[],
    menuList:[
      {
          type:'pizza',
          menus:[
             {
            title:'pizza one',
            img:'pizza.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'12',
            discount:'20'
            },
            {
            title:'pizza two',
            img:'pizza_one.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
            },
            {
            title:'pizza three',
            img:'pizza_three.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
          }
          ]
      },
      {
        type:'burgures',
        menus:[
            {
               title:'Chicken Burger',
              img:'Chicken Burger.png',
              description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
              price:'32',
              discount:''
            },
            {
            type:'burgures',
            title:'Fish Burger',
            img:'Fish Burger.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'20',
            discount:'10'
          },
          {
            title:'KFC Double',
            img:'KFC Double .png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'22',
            discount:''
          },
          {
            title:'Chicken Burger',
            img:'Chicken Burger.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
          },
          {
            title:'Big Burger',
            img:'Big Burger .png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'34',
            discount:''
          },
          {
            title:'Burger Fries',
            img:'Burger Fries.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'40',
            discount:'6'
          }
        ],
        
      },
      {
          type:'chickens',
          menus:[
             {
            title:'Kfc Signature Box',
            img:'Kfc Signature Box.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'12',
            discount:'20'
            },
            {
            title:'Kfc Twister Box',
            img:'Kfc Twister Box.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
            },
            {
            title:'Kfc Chicken Nuggets',
            img:'Kfc Chicken Nuggets.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
          }
          ]
      },
      {
          type:'salad',
          menus:[
             {
            title:'Lamb Kebab With Salad',
            img:'Lamb Kebab With Salad.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'12',
            discount:'20'
            },
            {
            title:'Fattoush Salad',
            img:'Fattoush Salad.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
            },
            {
            title:'Fattoush Salad with Cucumber and Tomato',
            img:'Fattoush Salad with Cucumber and Tomato.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
          }
          ]
      },
      {
          type:'desserts',
          menus:[
             {
            title:'Ice Cream Berries',
            img:'Ice Cream Berries.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'12',
            discount:'20'
            },
            {
            title:'Strawberry Horn Ice Cream',
            img:'Strawberry Horn Ice Cream.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
            },
            {
            title:'Strawberry Parfait Ice Cream',
            img:'Strawberry Parfait Ice Cream.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
          }
          ]
      },
      {
          type:'drinks',
          menus:[
             {
            title:'Can Pepsi ',
            img:'Can Pepsi .png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'12',
            discount:'20'
            },
            {
            title:'Regular Coke Can Coca Cola',
            img:'Regular Coke Can Coca Cola.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
            },
            {
            title:'Fanta Orange Can',
            img:'Fanta Orange Can.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
          },
          {
            title:'Coca Cola Papercup',
            img:'Coca Cola Papercup.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'12',
            discount:'20'
            },
            {
            title:'Coke Light Bottle Coca Cola',
            img:'Coke Light Bottle Coca Cola.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
            },
            {
            title:'Plastic Bottle Pepsi ',
            img:'Fanta Orange Can.png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'120',
            discount:'15'
          },
          {
            title:'Fanta Orange Bottle ',
            img:'Fanta Orange Bottle .png',
            description:'Whitehaven Beach Whitsunday Island, Whitsunday Islands',
            price:'12',
            discount:'20'
            }
          ]
      }
  ],
  MainMenu:['pizza','burgures','chickens','salad','desserts','drinks']
  },
  getters:{
     getMenu(state){
       return state.menuListes;
     },
     getMainMenu(state){
       return state.MainMenu;
     }
  },
  mutations: {
    
  },
  actions: {
     
  },
  modules: {
  }
})
